import * as React from 'react'
import * as ReactRedux from 'react-redux'
import { Button } from 'reactstrap'
import * as Actions from './actions'
import * as Types from './types'

export interface PagerProps {
  goToPage: Actions.GoToPageAction,
  isLoading: boolean,
  lastPage: boolean,
  pageNumber: Types.PageNumber,
  prefix: string,
}

export const PagerComponent = ({pageNumber, lastPage, isLoading, goToPage, prefix}: PagerProps) =>
<div className="pagination">
  <Button disabled={isLoading || pageNumber <= 1} onClick={() => goToPage(pageNumber - 1, prefix)}>{'<< Prev'}</Button>
  <Button disabled={isLoading || lastPage} onClick={() => goToPage(pageNumber + 1, prefix)}>{'Next >>'}</Button>
</div>

export const Pager = ReactRedux.connect(
  ({}, ownProps) => ({...ownProps}),
  {
    goToPage: Actions.goToPage,
  },
)(PagerComponent)



// WEBPACK FOOTER //
// ./src/components/pager/component.tsx